<template>
  <div class="about">
    <h2>企业荣誉</h2>
    <p></p>
    <div class="about-content">
      <img src="../../static/images/about/ronyu.png" />
      <div class="right-tab">
        <div class="tab-nav">
          <div
            class="title-item"
            :class="{ active: tabIndex == item.id }"
            v-for="item in tabObj.topList"
            :key="item.id"
            @click="changeTabs(item.id)"
          >
            {{ item.title }}
          </div>
        </div>
        <div
          class="tab-content"
          v-show="tabIndex == item.id"
          v-for="item in tabObj.contentList"
          :key="item.id"
        >
          <div
            class="content-item"
            v-for="(s_item, s_index) in item.list"
            :key="s_index"
          >
            {{ s_item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  props: {
    aboutInfo: Object,
    // honorContent:Array
  },
  data() {
    return {
      tabIndex: 0,
      tabObj: {
        topList: [
          { id: 0, title: "奖项" },
          { id: 1, title: "合作单位" },
          { id: 2, title: "战略合作" },
          { id: 3, title: "合作商会" },
          { id: 4, title: "其他荣誉" },
        ],
        contentList: [
          // {
          //   id: 0,
          //   list: [
          //     "2014年  参与中国大学生计算机设计大赛荣获“省级一等奖”",
          //     "2015年  参与第四届中国创新创业大赛被评为“优秀团队”",
          //     "2015年  参与第二届“恺炬杯”惠州创新大赛，荣获“三等奖”",
          //   ],
          // },
          // {
          //   id: 1,
          //   list: [
          //     "2019年  成为腾讯大粤网 技术研究中心（惠州市）",
          //     "2019年  成为惠州软件协会  软件分发中心  总负责商",
          //     "2019年  成为惠州学院  实践教育基地",
          //     "2020年  成为惠州市技师学院  校企合作单位",
          //     "2020年  成为惠州经济职业技术学校  校企合作单位",
          //   ],
          // },
          // {
          //   id: 2,
          //   list: [
          //     "2019年  中国中铁股份有限公司成为“战略合作伙伴”",
          //     "2019年  中国石油化工集团公司成为“战略合作伙伴”",
          //     "2019年  深圳市银泰财富资产管理有限公司成为“战略合作伙伴”",
          //     "2019年  丰顺天籁文化传媒有限公司成为“战略合作伙伴”",
          //   ],
          // },
          // {
          //   id: 3,
          //   list: [
          //     "2019年  惠州市揭西商会  理事单位",
          //     "2019年  惠州市汕尾商会  会员单位",
          //     "2020年  惠州市企业联合会 惠州市企业家协会 会员单位",
          //     "2020年  惠州市揭西商会青年联合会 理事单位",
          //   ],
          // },
          // {
          //   id: 4,
          //   list: ["2020年  成为广东省“守合同重信”企业"],
          // },
        ],
      },
    };
  },
  async mounted() {
    await this.getHonorData();
  },
  methods: {
     getHonorData() {
       this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/enterprise_glory",
        null,
        (res) => {
          let that = this;
          let arrOne = [];
          let arrTwo = [];
          let arrThree = [];
          let arrFour = [];
          let arrFive = [];

          if (res.code == 1) {
            res.data.map((item) => {
              if (item.type == 1) {
                arrOne.push(item.content);
              } else if (item.type == 2) {
                arrTwo.push(item.content);
              } else if (item.type == 3) {
                arrThree.push(item.content);
              } else if (item.type == 4) {
                arrFour.push(item.content);
              } else if (item.type == 5) {
                arrFive.push(item.content);
              }
            });
            this.$set(this.tabObj.contentList, 0, { id: 0, list: arrOne });

            this.tabObj.contentList[1] = {
              id: 1,
              list: arrTwo,
            };
            this.tabObj.contentList[2] = {
              id: 2,
              list: arrThree,
            };
            this.tabObj.contentList[3] = {
              id: 3,
              list: arrFour,
            };
            this.tabObj.contentList[4] = {
              id: 4,
              list: arrFive,
            };

          }
        }
      );
    },
    changeTabs(id) {
      this.tabIndex = id;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.about {
  position: relative;
  max-width: 1920px;
  margin: 0 auto;
  width: 100%;
  padding: 80px 0 0;

  h2 {
    text-align: center;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    letter-spacing: 2px;
  }

  >p:first-of-type {
    border-bottom: 1px solid #F5BA1A;
    margin: 24px auto 0;
    width: 42px;
    height: 2px;
  }

  .about-content {
    display: flex;
    width: 78%;
    margin: 60px auto 0;

    img {
      width: 616px;
      height: 420px;
    }
  }

  .right-tab {
    margin-left: 80px;
  }

  .tab-nav {
    display: flex;
    margin-bottom: 64px;

    .title-item {
      line-height: 48px;
      text-align: center;
      width: 140px;
      height: 48px;
      background: #F5F5F5;
      font-size: 18px;
      font-weight: bold;
      color: #666666;
      cursor: pointer;
    }

    .title-item.active {
      position: relative;
      width: 140px;
      height: 48px;
      background: #FFC000;
      color: #333333;
    }

    .title-item.active::before {
      content: '';
      position: absolute;
      top: 48px;
      left: 60px;
      border-right: 8px solid transparent;
      border-left: 8px solid transparent;
      border-top: 8px solid #FFC000;
    }
  }

  .tab-content {
    height: 380px;
  }

  .content-item {
    position: relative;
    margin-bottom: 40px;
    margin-left: 52px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .content-item::before {
    content: '';
    position: absolute;
    top: 10px;
    left: -20px;
    width: 8px;
    height: 8px;
    background: #FFC000;
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutHonor.vue